import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useCookie } from '@spotahome/ui-library';

const DEFAULT_COOKIE_EXPIRATION = 60 * 60 * 24 * 7; // 7 days in seconds

const HomeCardBanner = ({
  name,
  component: BannerComponent,
  isOneColumnView = false,
  cookieExpiration = DEFAULT_COOKIE_EXPIRATION,
  className = ''
}) => {
  const CookieManager = useCookie();
  const [show, setShow] = useState(false);
  const cookieName = `sah-banner-${name}`;

  const handleHideClick = () => {
    CookieManager.setCookie(cookieName, 1, { maxAge: cookieExpiration });
    setShow(false);
  };

  useEffect(() => {
    const cookie = CookieManager.getCookie(cookieName);

    if (!cookie) {
      setShow(true);
    }
  }, []);

  return show ? (
    <div className={className}>
      <BannerComponent
        isOneColumnView={isOneColumnView}
        onHideClick={handleHideClick}
      />
    </div>
  ) : null;
};

HomeCardBanner.propTypes = {
  name: PropTypes.string.isRequired,
  component: PropTypes.element.isRequired,
  isOneColumnView: PropTypes.bool,
  cookieExpiration: PropTypes.number,
  className: PropTypes.string
};

export default HomeCardBanner;
